import { openAuthModal } from '../../repositories/header-frontend/v3/open-auth-modal/helpers';
import type { IMicrofrontendsAPI } from '../../../shared/types/microfrontends/headerFrontend';

export function createMicrofrontendsAPI(): IMicrofrontendsAPI {
  return {
    header: {
      openAuthModal,
    },
  };
}
